var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import BaseInputNumber from '@arco-design/web-react/es/InputNumber';
import cx from 'classnames';
import { useConfigContext } from '../config-provider';
// @ts-ignore
import IconCaretDown from '@arco-design/web-react/icon/react-icon/IconCaretDown';
// @ts-ignore
import IconCaretUp from '@arco-design/web-react/icon/react-icon/IconCaretUp';
import InputNumberAutosize from './input-number-autosize';
import ErrorTip from '../input/error-tip';
var InputNumber = function (props, ref) {
    var _a;
    var common = useConfigContext().prefixCls;
    var prefixCls = common + "-input-number";
    var defaultIcons = {
        down: React.createElement(IconCaretDown, null),
        up: React.createElement(IconCaretUp, null),
    };
    var className = props.className, _b = props.icons, icons = _b === void 0 ? defaultIcons : _b, hideControl = props.hideControl, _c = props.autoSize, autoSize = _c === void 0 ? false : _c, error = props.error, errorTip = props.errorTip, wrapperStyle = props.wrapperStyle, textAlign = props.textAlign;
    var prefixHideControlCls = prefixCls + "-hide-control";
    var textAlignCls = textAlign ? "text-align-" + textAlign : '';
    return (React.createElement("div", { style: wrapperStyle },
        autoSize ? (React.createElement(InputNumberAutosize, __assign({}, props, { ref: ref }))) : (React.createElement(BaseInputNumber, __assign({}, props, { ref: ref, icons: icons, className: cx(className, prefixCls, textAlignCls, (_a = {}, _a[prefixHideControlCls] = hideControl, _a)) }))),
        React.createElement(ErrorTip, { show: error }, errorTip)));
};
export default React.forwardRef(InputNumber);
//# sourceMappingURL=index.js.map